// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxInput_container__1KIQ1","checkbox":"CheckboxInput_checkbox__747NB"};